import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useMe } from '@/lib/auth';

export function RequireAuth({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();

  if (me.isLoading) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-[var(--color-foreground-subtle)]">
        Loading…
      </div>
    );
  }
  if (!me.data) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
